export var AUTH_STATE_CHANGED = "@@firekit/AUTH@AUTH_STATE_CHANGED";
export var AUTH_ERROR = "@@firekit/AUTH@AUTH_ERROR";